if (!customElements.get('new-plan-box')) {
  customElements.define(
    'new-plan-box',
    class NewPlanBox extends HTMLElement {
      constructor() {
        super();
        
        this.onBodyClick = this.onBodyClick.bind(this);
        this.addEventListener('click', this.onBodyClick);
        this.form = document.querySelector('form.form[action="/cart/add"]');
        this.containerDiv = this.closest('.new-plan-choose-box');
        this.allBoxes = this.containerDiv.querySelectorAll('.new-plan-box');
        this.myBox = this.querySelector('.new-plan-box');

        this.variantInput = document.querySelector('input[type="hidden"].product-variant-id');
        this.productInput = document.querySelector('input[type="hidden"][name="product-id"]');
        this.cartTextSpan = this.form.querySelector('button[type="submit"][name="add"] span');
        
        if (this.dataset.isSelected && window.getComputedStyle(this).display !== 'none') {
          this.cartTextSpan.innerText = "ADD TO CART - " + this.dataset.price;
          this.variantInput.value = this.dataset.variantId;
        }
        this.perkBox = this.containerDiv.querySelector('.new-plan-perks');
      }

      onBodyClick() {
        if (this.myBox.classList.contains('active')) {
          return;
        }

        if (!this.form.querySelector('input[type="hidden"][name="selling_plan"]')) {
          const input = document.createElement('input');
          input.type='hidden';
          input.name='selling_plan';
          this.form.appendChild(input);
        }

        this.allBoxes.forEach(div => div.classList.remove('active'));
        this.myBox.classList.add('active');

        this.variantInput.value = this.dataset.variantId;
        this.productInput.value = this.dataset.productId;
        this.form.querySelector('input[type="hidden"][name="selling_plan"]').value = this.dataset.sellingPlanId;
        this.cartTextSpan.innerText = "ADD TO CART - " + this.dataset.price;

        if (this.dataset.isPerk) {
          this.perkBox.classList.add('active');
        } else {
          this.perkBox.classList.remove('active');
        }
      }
    }
  );
}
